import Vue from 'vue'
import App from './App.vue'
import moment from 'moment'
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import router from '@/router'
import store from '@/store'
import Vuelidate from 'vuelidate'
import AlertsMixin from './mixins/alertsMixin'
import vueDebounce from 'vue-debounce'
import apiHandleMixin from "./mixins/apiHandleMixin";

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import '@/assets/fonts/fontawesome-all.css'
import '@/api/'
import 'vue-multiselect/dist/vue-multiselect.min.css'
import './style/Global.scss'
import 'vue2-datepicker/index.css';


Vue.config.productionTip = false
Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.use(Vuelidate)
Vue.use(vueDebounce)

Vue.mixin(AlertsMixin)
Vue.mixin(apiHandleMixin)


Vue.filter('formatDate', function (value) {
  if (value) {
    return moment.utc(String(value)).local().format('DD/MM/YYYY HH:mm')
  }
});

Vue.filter('formatDateLeadingTime', function (value) {
  if (value) {
    return moment.utc(String(value)).local().format('HH:mm DD/MM/YYYY')
  }
});
Vue.filter('formatOnlyDate', function (value) {
  if (value) {
    return moment.utc(String(value)).local().format('DD/MM/YYYY')
  }
});
Vue.filter('formatOnlyTime', function (value) {
  if (value) {
    return moment.utc(String(value)).local().format('HH:mm')
  }
});

Vue.filter('formatOnlyDateWithDayOfWeek', function (value) {
  if (value) {
    return moment.utc(String(value)).local().format('dddd - DD/MM/YYYY')
  }
});
Vue.filter('formatAddress', function (value) {
  if (value) {
    return value.address1 + (value.address2 ? `, ${value.address2}` : ``) +
      (value.town ? `, ${value.town}` : ``) + (value.postCode ? `, ${value.postCode}` : ``)
  }
});

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
